import { StatusBannerDisplay } from '@xing-com/banner';

import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsErrorBannerProps = {
  display?: StatusBannerDisplay;
};

export type SearchAlertsErrorBannerXinglet =
  XingletInterface<SearchAlertsErrorBannerProps>;

export const SearchAlertsErrorBanner =
  JobsXingletWrapper<SearchAlertsErrorBannerProps>(
    '@xing-com/crate-jobs-domain-search-alerts-error-banner'
  );
